import { render, staticRenderFns } from "./ad-share.vue?vue&type=template&id=fde72de4&"
import script from "./ad-share.vue?vue&type=script&lang=js&"
export * from "./ad-share.vue?vue&type=script&lang=js&"
import style0 from "./ad-share.vue?vue&type=style&index=0&id=fde72de4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports